module.exports = __webpack_public_path__ + "static/media/cl_flow.a780b729.jpg";